import { useEffect, useState } from 'react';
import { store } from '../redux/store';
import { createGrantedPolicySelector } from '../redux/selectors/appSelector';

export function usePermission(key) {
  const [permission, setPermission] = useState(false);

  const state = store.getState();
  const policy = createGrantedPolicySelector(key)(state);

  useEffect(() => {
    setPermission(policy);
  }, [policy]);

  return permission;
}
